import React, { useState, useEffect } from 'react';
import { Splitter, SplitterOnChangeEvent, SplitterPaneProps } from '@progress/kendo-react-layout';
import cn from 'clsx';
import { CoreSplitterProps } from '@components-clean/core/core-splitter/core-splitter.interface';

const CoreSplitter = ({
    orientation,
    alignmentValues,
    onResize,
    className,
    'data-testid': testid,
    children,
    onChange: handleOnChange,
}: CoreSplitterProps) => {
    const panesSettings = !!alignmentValues
        ? alignmentValues
        : [
              { min: '20%' },
              {
                  min: '20%',
                  size: '30%',
                  keepMounted: true,
              },
          ];
    const [panes, setPanes] = useState<Array<SplitterPaneProps>>(panesSettings);

    useEffect(() => {
        if (onResize) {
            onResize();
        }
    }, [orientation]);

    useEffect(() => {
        setPanes(alignmentValues || []);
    }, [alignmentValues]);

    const onChange = (event: SplitterOnChangeEvent) => {
        setPanes(event.newState);
        if (event.isLast) {
            if (onResize) {
                onResize();
            }
        }
        handleOnChange && handleOnChange(event);
    };

    return (
        <Splitter
            panes={panes}
            onChange={onChange}
            orientation={orientation}
            className={cn(className)}
            data-testid={testid}
        >
            {children}
        </Splitter>
    );
};

export default CoreSplitter;
